import axios from "axios";

const BASE_URL = `/training-sessions`;

export const update=(payload)=>{
    return axios.put(`${BASE_URL}/${payload.sessionId}/participants/${payload.id}`, {
        isAnimator: payload.isAnimator
    })
        .then((res) => {
            return res.data;
        }).catch((err) => {
            console.log(err);
            if (err.response != null) {
                throw Error(err.response.data.message||"unknown");
            }
            throw Error(err);
        });
};